import type { ResourceScope } from 'src/types/global'
import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { QUERY_BUILDER_URL } from 'src/constants/global'
import { DashboardListItem } from 'src/types/dashboard'

export interface DashboardListResponse {
  dashboards: DashboardListItem[]
}

export const useDashboardListData = (
  scope: ResourceScope
): DashboardListItem[] => {
  const { dashboards } = useFetch<DashboardListResponse>(
    QUERY_BUILDER_URL + '/dashboards/' + scope
  )
  return dashboards
}
